import { CategoryListInterface } from "../../interfaces/CategoryListInterface";
import { JSX, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import {
    ProductGridItem,
    ProductListHeader,
    ProductListItem,
} from "@hatch-digital-nl/bravilor-storybook";
import { useNavigate } from "react-router-dom";
import { RouteEnum } from "../../enums/RouteEnum";
import { getLocalizedText } from "../../utils/getLocalizedText";
import { convertProduct } from "../../utils/productConverter";
import { asStorybookProduct } from "../../utils/storybookProduct";
import { SimpleProduct } from "../../interfaces/SimpleProduct";

interface Props {
    child: CategoryListInterface;
    disableCheckbox?: boolean;
    productImages: { [key: string]: string };
}

export const CategorySubItem = (props: Props): JSX.Element | null => {
    const { child, productImages } = props;
    const { products, children } = child;
    const navigate = useNavigate();

    const [active, setActive] = useState(false);

    const { gridLayout } = useAppSelector((state) => state.productRange);

    const handleProductClick = (product: SimpleProduct): void => {
        navigate(RouteEnum.PRODUCT_RANGE + `/${product.id}`);
    };

    if (
        (!!children &&
            children.length > 0 &&
            children.some(
                (item) => item.products && item.products.length > 0,
            )) ||
        (!!products && products.length > 0)
    ) {
        return (
            <div
                className={
                    "c-products-list__sub-item " +
                    (active ? "is-active " : "in-active ") +
                    (!!children && children.length > 0
                        ? "c-products-list__sub-item--active-white"
                        : "")
                }
            >
                <ProductListHeader
                    isActive={active}
                    onToggle={() => setActive(!active)}
                    label={getLocalizedText(child.label)}
                    showIcon={true}
                    variant={"sub"}
                />

                {!!children && children.length > 0 ? (
                    <div className="c-products-list__sub-items">
                        {children.map((item) => (
                            <CategorySubItem
                                key={"category-" + item.id}
                                child={item}
                                disableCheckbox={props.disableCheckbox}
                                productImages={productImages}
                            />
                        ))}
                    </div>
                ) : (
                    <div
                        className="c-products-list__sub-items"
                        style={{ padding: 0 }}
                    >
                        <div
                            className={
                                "c-products-list__sub-item " +
                                (active ? "is-active" : "in-active")
                            }
                            style={{ margin: 0 }}
                        >
                            {!!products && products.length > 0 && (
                                <div
                                    className={
                                        "c-products-list__sub-item__items " +
                                        (gridLayout
                                            ? "c-products-list__sub-item__items--grid"
                                            : "")
                                    }
                                >
                                    {products.map((product) => {
                                        if (gridLayout) {
                                            const gridProduct: SimpleProduct =
                                                convertProduct(
                                                    product,
                                                    productImages,
                                                    "grid",
                                                );
                                            return (
                                                <ProductGridItem
                                                    key={"grid-" + product.id}
                                                    product={asStorybookProduct(
                                                        gridProduct,
                                                    )}
                                                    showSelectCheckbox={false}
                                                    viewProductText={
                                                        "View Product"
                                                    }
                                                    onProductClick={(
                                                        selectedProduct,
                                                    ) =>
                                                        handleProductClick(
                                                            selectedProduct as SimpleProduct,
                                                        )
                                                    }
                                                    lazyLoad={true}
                                                />
                                            );
                                        }
                                        const listProduct: SimpleProduct =
                                            convertProduct(
                                                product,
                                                productImages,
                                                "list",
                                            );
                                        return (
                                            <ProductListItem
                                                key={"list-" + product.id}
                                                product={asStorybookProduct(
                                                    listProduct,
                                                )}
                                                showSelectCheckbox={false}
                                                redirectUrl={
                                                    RouteEnum.PRODUCT_RANGE +
                                                    `/${product.id}`
                                                }
                                            />
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return null;
};
